<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section class="features">
  <div class="container" data-aos="fade-up">
    <div class="row feature-icons" data-aos="fade-up">
      <h3 style="padding-bottom: 40px;">{text(block, 'headline')}</h3>

      <div class="row p-0">

        <div class="col-xl-4 text-center p-0" data-aos="fade-right" data-aos-delay="100">
          <img src="{image(block, 'picture', [null, 800])}" class="p-4 d-block"
               style="margin: 0px auto; width: 80%;" alt="">
        </div>

        <div class="col-xl-8 d-flex content">
          <div class="row align-self-center gy-4">

            {#each blocklist(block, 'features') as item}
            <div class="col-md-6 icon-box" data-aos="fade-up">
              <!-- <i class="ri-line-chart-line"></i> -->
              <a href="{url(item, 'link')}">
                <img src="{image(item, 'icon', [null, 200])}" style="height: 70px;" alt="">
              </a>
              <div class="px-3">
                <h4>{text(item, 'title')}</h4>
                <p>{text(item, 'text')}</p>
              </div>
            </div>
            {/each}

          </div>
        </div>

      </div>

    </div>
  </div>
</section>

<style>
  .features .feature-icons {
      margin-top: 0px !important;
  }

  .icon-box > img {
      align-self: start;
  }

  .row {
      --bs-gutter-x: 0rem;
  }
</style>
